import {inject, injectable} from 'inversify';

import {AudioModelFactory} from '../../../../../../core/models/Audio/AudioModel.factory';
import {ArticleAudioPlayerState} from './ArticleAudioPlayer.state';

@injectable()
export class ArticleAudioPlayerStateFactory {
  constructor(
    @inject(AudioModelFactory)
    private readonly audioModelFactory: AudioModelFactory,
  ) {}

  create(props: ArticleAudioPlayerState.Props) {
    return new ArticleAudioPlayerState(props, this.audioModelFactory);
  }
}
